import RegisterFormComponent from "src/components/user/register_form_component";

function RegisterConatiner() {
  return (
    <div className="flex items-center justify-center z-40 relative pt-[88px] pb-11 mobile:mx-6">
      <RegisterFormComponent />
    </div>
  );
}

export default RegisterConatiner;
